<template>
  <div class="bg-blue">
    <!-- 상단 고정 캠페인 배너 -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :staticMode="false"
    ></TopAppBar>
    <div class="pdb-20" v-if="purchaseDetails">
      <div id="tab1" class="t-color-content1 pdt-16 pdl-16 pdr-16">
        <div class="bg-white mgt-60">
          <div class="headerRoll position-relative">
            <div class="bg-white position-relative h-29 z-99">
              <div class="header-shadow"></div>
            </div>
          </div>
        </div>
        <div class="pdl-16 pdr-16 receipt-wrapper position-relative bg-white">
          <div class="t-subtitle2 t-color-title l-spacing48 font-rb">Prize</div>
          <div class="t-body1 t-color-title l-spacing48 pdt-16 pdb-16 font-r">
            {{
              purchaseDetails && purchaseDetails.product
                ? purchaseDetails.product.name
                : ""
            }}
          </div>
          <div class="divider"></div>
          <div class="t-body3 t-color-content1 pdt-18 pdb-5 font-r l-spacing42">
            {{ $t("1043") }}
          </div>
          <div class="t-body1 t-color-title pdb-10 l-spacing42 f-weight500">
            {{
              $moment(purchaseDetails.buyRequestDatetime).format("YYYY.MM.DD")
            }}
          </div>

          <div class="divider dashed mgb-8 mgt-8"></div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20013") }}
          </div>
          <div class="d-flex align-items-center">
            <div class="pdr-3 t-body3 t-color-title">
              <div class="mgr-2">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
            </div>
            <div class="t-body1 t-color-red1 l-spacing42 pdl-4">
              {{ pay_through_points }}
            </div>
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20014") }}
          </div>
          <div class="d-flex align-items-center">
            <div class="pdr-3 t-body3 t-color-title">
              <div class="mgr-2">
                <img
                  src="images/prize_request/p-image.svg"
                  class="w-24 h-24"
                  alt=""
                />
              </div>
            </div>
            <div class="t-body1 t-color-title l-spacing42 pdl-4">
              {{ remaining_points }}
            </div>
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("1992") }}
          </div>
          <div class="t-body1 t-color-title pdb-10 l-spacing42 font-r">
            {{
              purchaseDetails && purchaseDetails.quantity
                ? purchaseDetails.quantity
                : ""
            }}
          </div>

          <!-- <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            할인된 금액
          </div>
          <div class="d-flex">
            <div class="t-body3 t-color-title pdb-10 font-r l-spacing42">
              KRW
            </div>
            <div class="t-body1 t-color-title pdb-10 l-spacing42 pdl-4">
              - 7,000
            </div>
          </div> -->
          <div class="divider dashed mgb-8 mgt-8"></div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20015") }}
          </div>
          <div class="t-body1 t-color-title pdb-10 l-spacing42">
            {{
              purchaseDetails && purchaseDetails.shippingInfo
                ? purchaseDetails.shippingInfo.name
                : ""
            }}
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20018") }}
          </div>
          <div class="t-body1 t-color-title pdb-10 l-spacing42">
            {{
              purchaseDetails && purchaseDetails.shippingInfo
                ? purchaseDetails.shippingInfo.email
                : ""
            }}
          </div>

          <div class="divider dashed mgb-8 mgt-8"></div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20020") }}
          </div>

          <div
            class="t-body1 t-color-title l-spacing42" v-if="purchaseDetails"
          >
            {{ getPurchaseStatusText(purchaseDetails.status.value) }}
          </div>

          <!-- APPROVED, EMAIL_SENT 일 경우 helper text 추가 -->
          <div
            class="t-helper t-color-red1 pdb-10" 
            v-if="purchaseDetails && purchaseDetails.status.value === prizeConstants.approved || purchaseDetails.status.value === prizeConstants.mailSent"
          >
            {{ getPurchaseHelperText(purchaseDetails.status.value) }}
          </div>

          <div class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42">
            {{ $t("S20021") }}
          </div>
          <div
            v-if="
              purchaseDetails &&
              purchaseDetails.status &&
              purchaseDetails.status.value === prizeConstants.checkingOrder
            "
          >
            <div class="t-body1 t-color-title pdb-26 l-spacing42">-</div>
          </div>
          <div v-else>
            <div class="t-body1 t-color-title pdb-26 l-spacing42">
              {{
                $moment(purchaseDetails.buyer.handleDatetime).format(
                  "YYYY.MM.DD"
                )
              }}
            </div>
          </div>

          <div
            v-if="
              purchaseDetails &&
              purchaseDetails.status &&
              purchaseDetails.status.value === prizeConstants.reject
            "
          >
            <div
              class="t-body3 t-color-content1 pdt-10 pdb-5 font-r l-spacing42"
            >
              {{ $t("S20023") }}
            </div>
            <div class="t-body1 t-color-title pdb-26 l-spacing42">
              {{ purchaseDetails.rejectReason }}
            </div>
          </div>

          <!--  -->
        </div>
      </div>
      <div class="receipt-wrapper-bottom h-20 mgl-14 mgr-16"></div>

      <div class="pdl-16 pdr-16 mgb-34 mgt-50">
        <router-link
          class="d-block btn-red t-center pdt-11 pdb-10 t-color-white b-radius4 mgt-16 mgb-24 b-shadow2 t-body2"
          to="/prize-request?listType=history"
        >
          {{ $t("S20022") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define

import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import { MDCRipple } from "@material/ripple";
import prizeRequestApi from "@/api/prizeRequestApi.js";
import NoData from "../common/NoData.vue";
import prizeConstants from "@/utils/constants/prizeConstants"

export default {
  components: {
    NoData,

    TopAppBar,
  },

  data() {
    return {
      status: "",
      prize_id: null,
      leftBtnMethod: () => {
        this.$router.go(-1);
      },
      purchaseDetails: null,
      pay_through_points: 0,
      remaining_points: 0,
      user_points: localStorage.getItem("user_point"),
    };
  },

  computed: {
    prizeConstants() {
      return prizeConstants;
    }
  },

  watch: {
    $route(to, from) {
      this.initData();
    },
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarBack(this.$t("1021"));
    this.prize_id = this.$route.params.prizeid;

    this.fetchData();
  },

  methods: {
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      prizeRequestApi
        .prizePurchaseDetailHistory(this.prize_id)
        .then((response) => {
          console.log("purchase history details", response.data.data);
          this.purchaseDetails = response.data.data;
          this.pay_through_points =
            this.purchaseDetails.product.price * this.purchaseDetails.quantity;
          this.remaining_points = this.user_points - this.pay_through_points;
        })
        .catch((err) => {});
    },

    getPurchaseStatusText(status) {
      const statusMap = {
        CHECKING_ORDER: this.$t("S20038"),
        COMPLETED: this.$t("S20039"),
        REJECT: this.$t("S20040"),
        APPROVED: this.$t("S20131"),
        MAIL_SENT: this.$t("S20133"),
      };
      // 상태값이 없는 경우 기본값 처리
      return statusMap[status] || '';
    },

    getPurchaseHelperText(status) {
      const statusMap = {
        APPROVED: this.$t("S20132"),
        MAIL_SENT: this.$t("S20134"),
      };
      // 상태값이 없는 경우 기본값 처리
      return statusMap[status] || '';
    },
  },
};
</script>

<style scoped>
.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z4 {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  /* background-color: #ffffff; */
}

.no-border {
  border: none;
  outline: none;
  box-shadow: none;
}
.t-color-dark {
  color: #313d4b;
}
.header-shadow {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
}
.header-shadow:before {
  width: 100%;
  height: 29px;
  opacity: 0.7;
  background-image: linear-gradient(
    to bottom,
    #acb4be,
    rgba(219, 219, 219, 0) 67%
  );
  position: absolute;
  content: "";
  left: 50%;
  transform: translateX(-50%);
  top: 0;
}
.headerRoll:after,
.headerRoll:before {
  width: 20px;
  height: 14px;
  border-radius: 7px;
  background-color: #80aed4;
  position: absolute;
  content: "";
  top: 0;
  transform: translateX(-50%);
}
.headerRoll:after {
  right: -20px;
}
.headerRoll:before {
  left: 0;
}
.z-99 {
  z-index: 99;
}
.l-spacing5 {
  letter-spacing: 0.5px;
}
.receipt-wrapper-bottom {
  background: url("/images/prize_request/border-bottom1.svg");
  margin-top: -11px;
}
.f-weight500 {
  font-weight: 500 !important;
}
.bg-blue1 {
  background: #2d6dcc !important;
}
</style>
